module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.8ac55d39.ttf";